import { ModalSavingBeforeLeaving } from "components/Organisms/modals";
import React from "react";

const useNotifySavingBeforeExit = ({ onLeave, onStay }: any) => {
  const [visible, setVisible] = React.useState(false);
  const hideModal = () => {
    setVisible(false);
  };
  const showModal = () => {
    setVisible(true);
  };

  const renderModal = () => {
    return (
      <ModalSavingBeforeLeaving
        visible={visible}
        onCancel={() => {
          hideModal();
          onLeave();
        }}
        onOk={() => {
          hideModal();
          onStay && onStay();
        }}
      ></ModalSavingBeforeLeaving>
    );
  };
  return [renderModal, showModal, hideModal];
};
export default useNotifySavingBeforeExit;
